import { Checkbox, Group, NumberInput, Text } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';
import { TimeWindowField } from '../TimeWindowField';

export const NumberOfMeasurementFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const dataField = 'data.heartRhythmMeasurement.numberOfMeasurementsCondition';
  const numberOfDaysEnabled = values.data.heartRhythmMeasurement.numberOfDaysCondition?.enabled ?? false;

  return (
    <AccordionWithSwitch
      title={`${t('number_of_measurements_label')} *`}
      dataField={dataField}
      disabled={numberOfDaysEnabled}
    >
      <Text size={'xs'} mb={-5} c={'var(--mantine-color-blue-5)'}>
        {t('number_of_measurements_description')}
      </Text>
      <Group gap={'xl'} align={'flex-start'}>
        <NumberInput
          label={t('count_label')}
          {...getInputProps(`${dataField}.numberOfMeasurements.amount`)}
          allowNegative={false}
          allowDecimal={false}
          min={1}
          max={1000}
          disabled={values.formDisabled}
          clampBehavior={'strict'}
          error={displayFormError({ errors, dataField: `${dataField}.numberOfMeasurements.amount` })}
        />
        <TimeWindowField dataField={`${dataField}.numberOfMeasurements.timeWindow`} />
      </Group>
      <Checkbox
        label={t('require_consecutive_label')}
        {...getInputProps(`${dataField}.numberOfMeasurements.isConsecutive`, {
          type: 'checkbox',
        })}
        disabled={values.formDisabled}
      />
    </AccordionWithSwitch>
  );
};
